import React, { useEffect, useState } from 'react';
import { useItemContext } from '../contexts/ItemContext';

import { useTelegram } from "../hooks/useTelegram"
import Block from '../assets/block.png';
import './Notification.scss'; // Import the CSS for styling

const Notification = () => {
    
    const { tg, triggerHapticFeedback } = useTelegram();
    const { handleClearCart, showNotification } = useItemContext();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (showNotification) {
            setVisible(true);
            const timer = setTimeout(() => {
                setVisible(false);
            }, 6000);
            return () => clearTimeout(timer);
        }
        setVisible(false);
    }, [showNotification, visible]);

    const handleClearCartItems = () => {
        triggerHapticFeedback('impact', 'medium');
        handleClearCart();
        setVisible(false);
    };
    return (
        <div className={`notification ${visible ? 'visible' : ''}`}>
            <div className="notification-content">
                <img src={Block} />
                <p className="notification-text">Вы не можете добавлять товары из разных игр в корзину одновременно.</p>
            </div>
            <div className="notification-content">
                <p className="notification-text">Удалите предыдущие товары и добавьте новый.</p>
                <button className="notification-button" onClick={handleClearCartItems}>Удалить</button>
            </div>
        </div>
    );
};

export default Notification;
